import React from 'react';

interface RadioButtonProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type' | 'size'> {
  label?: string;
  size?: 'small' | 'default';
}

export const RadioButton: React.FC<RadioButtonProps> = ({
  label,
  size = 'default',
  className,
  checked,
  disabled,
  ...props
}) => {
  const sizeClasses = {
    small: 'w-4 h-4',
    default: 'w-5 h-5',
  };

  const dotSizeClasses = {
    small: 'w-2 h-2',
    default: 'w-2.5 h-2.5',
  };

  return (
    <label className={`flex items-center gap-3 cursor-pointer ${disabled ? 'cursor-not-allowed opacity-60' : ''} ${className || ''}`}>
      <div className="relative">
        <input
          type="radio"
          checked={checked}
          disabled={disabled}
          className="sr-only"
          {...props}
        />
        <div
          className={`${sizeClasses[size]} rounded-full border-2 transition-colors duration-150 ${
            checked 
              ? 'border-primary' 
              : 'border-border hover:border-border-hover'
          } ${disabled ? '' : 'hover:border-primary/70'}`}
        >
          {checked && (
            <div 
              className={`${dotSizeClasses[size]} rounded-full bg-primary absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2`}
            />
          )}
        </div>
      </div>
      {label && (
        <span className={`text-sm text-text-primary select-none ${disabled ? 'opacity-60' : ''}`}>
          {label}
        </span>
      )}
    </label>
  );
};